"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _axios = _interopRequireDefault(require("axios"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    lookupList: {
      type: Object,
      default: function _default() {
        return {
          VISIT_PURPOSE: ''
        };
      }
    }
    // isBaiLian: {
    //   type: Boolean,
    //   default: false
    // }
    // list: {
    //   type: Array,
    //   default: () => ([])
    // }
  },
  data: function data() {
    return {
      url: '',
      srcList: [],
      pageName: 'visitRecord',
      listLoading: false,
      total: 0,
      currentId: null,
      isShowModel: false,
      currPage: 1,
      limit: 10,
      list: [],
      checkList: []
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getConfigItemCodeList();
    }
  },
  mounted: function mounted() {
    this.getConfigItemCodeList();
  },
  methods: {
    getConfigItemCodeList: function getConfigItemCodeList() {
      var _this = this;
      var param = {
        configItemCodeList: ['Visit_Report_Check_list']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        var data = res.data || {};
        _this.checkList = data['Visit_Report_Check_list'] || [];
      });
    },
    // 移除“N”
    formatN: function formatN(key) {
      return key === 'N' ? '' : key;
    },
    // 格式化
    formatVoptions: function formatVoptions(key) {
      if (!key || !this.lookupList['VISIT_PURPOSE']) {
        return '';
      }
      var txt = key || '';
      this.lookupList['VISIT_PURPOSE'].some(function (item) {
        var bool = item.code === key;
        if (bool) {
          txt = item.name;
        }
        return bool;
      });
      return txt;
    },
    formatterGoodContent: function formatterGoodContent(goodContentList) {
      var _this2 = this;
      var goodContentStrList = goodContentList.map(function (item) {
        return _this2.lookupList['RECORD_FEEDBACK_GOOD_MAPPING'][item] || item;
      });
      return goodContentStrList.join('；');
    },
    formatterBadContent: function formatterBadContent(badContentList) {
      var _this3 = this;
      var badContentStrList = badContentList.map(function (item) {
        return _this3.lookupList['RECORD_FEEDBACK_BAD_MAPPING'][item] || item;
      });
      return badContentStrList.join('；');
    },
    formatterUrgentDeliveryTime: function formatterUrgentDeliveryTime(item) {
      return this.lookupList['URGENT_DELIVERY_TIME_MAPPING'][item] || item;
    },
    formatterRegularDeliveryTime: function formatterRegularDeliveryTime(item) {
      return this.lookupList['REGULAR_DELIVERY_TIME_MAPPING'][item] || item;
    },
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData(retailorStoreInfoPk) {
      var _this4 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          retailorStoreInfoPk: retailorStoreInfoPk
        }
      };
      this.listLoading = true;
      this.$api.retailorStore.getVisitList(param, this.sourceApi.token).then(function (res) {
        _this4.listLoading = false;
        _this4.list = res.data.items;
        _this4.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this4.listLoading = false;
      });
    },
    // 打开Enote
    openEnote: function openEnote(planTaskInfoPk) {
      this.$refs['enote'].init(planTaskInfoPk);
    }
  }
};